// removes trailing '/' for urls
export default url => {
  const lastIndex = url.length - 1;
  if (url[lastIndex] === '/') {
    return url.substring(0, lastIndex);
  }
  return url;
};
